"use strict";
import {addClass, findIn, findAll, setAttribute} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import axios from "axios";
import {showNotification} from '@elements/alert-notification';
import Tooltip from "bootstrap/js/dist/tooltip";

export function init() {

    onFind('.js-availability', function (element) {
        let url = element.getAttribute('data-availability-url');
        let articleItems = findAll('[data-item-id]');
        let data = [];

        articleItems.forEach(item => {
            let articleItemId = item.getAttribute('data-item-id');
            let articleProductId = item.getAttribute('data-product-id');
            let amountInput = findIn('.js-availability__amount', item);
            let unitInput = findIn('.js-availability__unit', item);

            if (articleItemId !== null && articleProductId !== null && amountInput !== null && unitInput !== null) {
                let items = {'id': articleItemId, 'productId': articleProductId, 'amount': amountInput.value, 'unit': unitInput.value}
                data.push(items);
            }
        });

        if(articleItems !== null && articleItems.length > 0) {
            loadAvailability(url, data);
        }
    });
}

export function loadAvailability(url, data) {
    let pendingRequest;

    pendingRequest = axios({method: 'POST', url: url, data: {item:data} });

    showNotification({closable: true});
    showNotification(pendingRequest.then((x) => x.data));

    pendingRequest.then((response) => {
        if(response.data['success']) {
            let items = response.data['items']
            items.forEach((el) => {
                /* find data in response */
                let id = el.articleId;
                let stateIcon = el.stateIcon;
                let stateText = el.stateText;
                let stock = el.stock;
                // let stateAdditionalText = el.stateAdditionalText;

                /* find dom elements */
                let articleItem = findAll('[data-item-id="'+id+'"]');

                articleItem.forEach((el) => {
                    const itemStateIcon = findIn(".js-availability__item-status", el);
                    const itemStateText = findIn(".js-availability__item-text", el);
                    const itemStateTooltip = findIn(".js-availability__item-tooltip", el);

                        /* set new data */
                        if (itemStateTooltip) {
                            if (itemStateIcon) {
                                addClass(stateIcon, itemStateIcon);
                            }
                            if (stock === 'longer-delivery') {
                                const existingTooltip = Tooltip.getInstance(itemStateTooltip);
                                if (existingTooltip) {
                                    existingTooltip.dispose();
                                }
                                itemStateTooltip.classList.remove('article__availability--tooltip');
                                if (itemStateText) {
                                    itemStateText.innerHTML = stateText;
                                    itemStateText.classList.remove('visually-hidden');
                                }
                                if (itemStateIcon) {
                                    itemStateIcon.classList.remove('article__availability-status--notext', 'visually-hidden');
                                }
                            } else {
                                setAttribute('data-bs-title', stateText, itemStateTooltip);
                                const existingTooltip = Tooltip.getInstance(itemStateTooltip);
                                if (existingTooltip) {
                                    existingTooltip.dispose();
                                }
                                new Tooltip(itemStateTooltip);
                                if (itemStateText) {
                                    itemStateText.innerHTML = stateText;
                                }
                            }
                        } else {
                            if (itemStateIcon) {
                                addClass(stateIcon, itemStateIcon);
                            }
                            if (itemStateText) {
                                itemStateText.innerHTML = stateText;
                            }
                        }

                        // if (stateAdditionalText !== "" && itemStateIcon !== null) {
                        //     addClass('is--long-description', itemStateIcon)
                        //     setAdditionalText(el, stateAdditionalText);
                        // }
                });

            });
        }
    }).catch((error) => {
        console.warn(error);
    });

    return pendingRequest;
}

const setAdditionalText = (el, stateAdditionalText) => {
    const tooltipTrigger = el.querySelector('.js-availability__tooltip-trigger');

    if (!tooltipTrigger) return

    const tooltip = new Tooltip(tooltipTrigger, {
        title: stateAdditionalText,
        placement: 'top',
        trigger: 'hover'
    });
}